( function() {

  var youtube = document.querySelectorAll( ".youtube" );
  
  for (var i = 0; i < youtube.length; i++) {
    
    var source = "https://img.youtube.com/vi/"+ youtube[i].dataset.embed +"/maxresdefault.jpg";
    
    var image = new Image();
        image.src = source;
        image.addEventListener( "load", function() {
          youtube[ i ].appendChild( image );
        }( i ) );
    
        youtube[i].addEventListener( "click", function() {

          var iframe = document.createElement( "iframe" );

              iframe.setAttribute( "frameborder", "0" );
              iframe.setAttribute( "allowfullscreen", "" );
              iframe.setAttribute( "allow", "autoplay" );
              iframe.setAttribute( "src", "https://www.youtube.com/embed/"+ this.dataset.embed +"?rel=0&autoplay=1&iv_load_policy=3&cc_load_policy=1&modestbranding=1&origin=https:\/\/www.sp-connect.com&playsinline=1&controls=1&loop=0&enablejsapi=1&widgetid=1" );

              this.innerHTML = "";
              this.appendChild( iframe );
        } );  
  };
  
} )();

console.log('custom js');
(function($) {
  console.log('custom js - jquery part ');

  $(function() {
    // Check if the current page is a collection page
       if (window.location.pathname.indexOf('/collections/') >= 0) {
      console.log('custom js - jquery part - collection');

      var tagname = decodeURIComponent('data-tags-' +  window.location.href.replace(/^[^\?]*\//, '').replace(/\?.*$/, '')).trim();
      var $items = $('.product-loop div['+tagname+']');

      $('.product-loop > h2').remove();
      var tags = {};

      $items.each(function () {
        tags[$(this).attr(tagname)] = $(this).attr(tagname);
      });

      var userLocale = Shopify.locale;
      var tagline = '';
      switch (userLocale){
         case 'ja':
          tagline = "スターターキット<br />あなただけのスターターキットを作ろう。";
          break;
        case 'de':
          tagline = "Sets - Erstelle dein persönliches Setup";
          break;
        case 'fr':
          tagline = "Crée ta propre configuration";
          break;
        case 'it':
          tagline = "Crea il tuo setup personale";
          break;
        case 'es':
          tagline = "Crea tu configuración personal";
          break;
        case 'nl':
          tagline = "Creëer je persoonlijke opstelling";
          break;
        default:
          tagline = "Bundles - Create your personal setup";
      }

      for(var tagval in tags) {
       
        console.log(tagval);
        if (tagval === 'Sets' || tagval === 'Bundles') {
          $('.product-loop').append('<h2>' + tagline + '</h2>');
        } else {
          $('.product-loop').append('<h2>' + tagval + '</h2> ');
        }
        $('.product-loop div['+tagname+'="'+tagval+'"]').appendTo($('.product-loop'));
        $('.product-loop').addClass('product-css-grid');
      }
    }
  });
})(jQuery);


function spUpdateDiscountMessage() {
  var codeCookieValue;
  var getCookie = function(name) {
   var value = "; " + document.cookie;
   var parts = value.split('; '+name+'=');
   if (parts.length == 2) return parts.pop().split(";").shift();
  };
  codeCookieValue = getCookie('discount_code');
  if(!codeCookieValue){
   console.log("No Discount Code");
  }
  if(codeCookieValue){
     console.log("Discount Code - " + codeCookieValue);
     $(".discount-message").each(function() {
     $(this).html("<div class='show-discount'> <i class='fa-solid fa-tag'></i> 割引クーポン「<span><strong>" + codeCookieValue + "</strong></span>」は適用されました。</div>");
   });
  }
}

(function($) {
  $(document).on('', spUpdateDiscountMessage);
  $(spUpdateDiscountMessage);
})(jQuery);	

// Parse the current URL
const url = new URL(window.location.href);

// Check if the pathname matches exactly "/collections/xtreme" or starts with "/collections/xtreme/" to allow for any additional path segments
if (url.pathname === '/collections/xtreme' || url.pathname.startsWith('/collections/xtreme/') || url.pathname === '/en/collections/xtreme' || url.pathname.startsWith('/en/collections/xtreme/')) {
  // Your existing code to change the website appearance
  document.documentElement.style.setProperty('--background', 'black');
  document.documentElement.style.setProperty('--nav-color', 'white');
  document.documentElement.style.setProperty('--header-text-color', 'white');
  document.documentElement.style.setProperty('--text-color', 'white');
  document.documentElement.style.setProperty('--header-wrapper-background', 'black');
  document.documentElement.style.setProperty('--section-padding', '160px');
  document.body.style.backgroundColor = 'black';
 
  var header = document.getElementById('header-wrapper');
  if (header) {
    header.style.backgroundColor = 'black';
  }


  // Uncomment and modify as needed
  // var submenus = document.querySelectorAll('.header__megamenu-wrapper, .header__nav__link--icon, .header__nav__submenu, .header__nav__sub-sub-menu, a.header__nav__link .second-level,  ul.header__nav__sub-sub-menu a.header__nav__link');
  // submenus.forEach(function(submenu) {
  //   submenu.style.backgroundColor = 'black'; 
  // });
}

document.addEventListener("DOMContentLoaded", function() {
  const videos = document.querySelectorAll('video');

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      // If the video element is in the viewport, play it, otherwise pause it
      if (entry.isIntersecting) {
        entry.target.play();
      } else {
        entry.target.pause();
      }
    });
  }, {
    // Options for the observer; threshold defines how much of the item must be visible for the callback to fire
    threshold: 0.5 // Adjust this value based on when you want the video to play (e.g., when 50% visible)
  });

  // Attach the observer to each video element
  videos.forEach(video => {
    observer.observe(video);
  });
});


